import styled from "styled-components";
import { BaseModalBackground } from "styled-react-modal";

export const SpecialModalBackground = styled(BaseModalBackground)`
  backdrop-filter: blur(5px);
`;